import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import axios from "axios";
import PropTypes from "prop-types";
import ViewData from "./ViewData";
import AddEditSellingPrice from "../AddEditSellingPrice";
import { SellingPriceContainer } from "./SellingPricesList.styled";
import "./SellingPricesList.scss";
/**
 * Enquiry List,
 * Path - /Enquiries
 * @see See [https://hesusstore.atlassian.net/wiki/spaces/HS/pages/2999615489/Site+-+Enquiry+view+page+-+Selling+prices)
 * @component
 */
const SellingPricesList = (props) => {
  const { t, columnList, objectId, objectType, enquiryData, page, countryId } =
    props;

  const [isRefreshList, setIsRefreshList] = useState(false);
  const [transportTypes, setTransportTypes] = useState([]);
  const [selectedSolutionIds, setSelectedSolutionIds] = useState([]);

  const [isEditSellingPricePopupVisible, setIsEditSellingPricePopupVisible] =
    useState(false);

  const createSellingPrice = () => {
    setIsEditSellingPricePopupVisible(true);
  };

  const closeSellingPriceEditPopup = () => {
    setIsEditSellingPricePopupVisible(false);
  };

  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  useEffect(() => {
    axios
      .get(
        `/transports?status=1&countries=${countryId}&orderBy=asc&limit=-1`,
        {}
      )
      .then((response) => {
        const responseData = response.data.transports.map((item) => {
          const tempData = {
            value: item.id,
            label: item.name,
          };
          return tempData;
        });
        setTransportTypes(responseData);
      })
      .catch((error) => {});
  }, []);

  const onRefreshData = () => {
    setIsRefreshList(true);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  return (
    <SellingPriceContainer className="selling-price-list">
      <ViewData
        isRefreshList={isRefreshList}
        updateRefeshStatus={updateRefeshStatus}
        requestId={objectId}
        transportTypes={transportTypes}
        enquiryData={enquiryData}
        createNewAction={createSellingPrice}
        page={page}
        setSelectedSolutionIds={setSelectedSolutionIds}
        selectedSolutionIds={selectedSolutionIds}
        countryId={countryId}
      />
      {isEditSellingPricePopupVisible && (
        <AddEditSellingPrice
          onClose={closeSellingPriceEditPopup}
          enquiryId={enquiryData?.id}
          enquiryData={enquiryData}
          onRefreshData={onRefreshData}
          selectedSolutionIds={selectedSolutionIds}
          countryId={parseInt(enquiryData?.site?.platformCountry.id, 10)}
        />
      )}
    </SellingPriceContainer>
  );
};

SellingPricesList.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};

SellingPricesList.defaultProps = {
  page: "enquiryView",
};

export default withTranslation()(SellingPricesList);
